(() => {
  document.documentElement.dataset.pnwLive = 'yes';
  const handles = window.PNW_SHOPIFY_HANDLE_MAP || {};
  const replacements = window.PNW_PART_REPLACEMENTS || {};
  const $ = (id) => document.getElementById(id);
  const clean = (value) => String(value || '').trim().toLowerCase();
  const resolvePartNumber = (value) => window.PNW_RESOLVE_PART_NUMBER ? window.PNW_RESOLVE_PART_NUMBER(value) : String(value || '').trim().toUpperCase();
  const money = (cents, currency = 'USD') => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((Number(cents) || 0) / 100);
  const handleFor = (sku) => {
    const value = clean(sku);
    return handles[value] || `part-${value.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}`;
  };

  function toast(message) {
    const element = $('toast');
    if (!element) return;
    element.textContent = message;
    element.classList.add('show');
    setTimeout(() => element.classList.remove('show'), 2800);
  }

  function escapeHtml(value) {
    const element = document.createElement('div');
    element.textContent = String(value || '');
    return element.innerHTML;
  }
  const normalizeTitleKey = (value) => clean(value).replace(/[^a-z0-9]+/g, ' ').trim();

  function dedupeRepeatedTitle(value) {
    let text = String(value || '').replace(/\s+/g, ' ').trim();
    const sections = text.split(/\s+[—|]\s+/).map((part) => part.trim()).filter(Boolean);
    if (sections.length > 1) {
      const firstKey = normalizeTitleKey(sections[0]);
      if (firstKey && sections.every((part) => normalizeTitleKey(part) === firstKey)) text = sections[0];
    }
    const words = text.split(/\s+/);
    const half = words.length / 2;
    if (Number.isInteger(half) && half > 0) {
      const left = words.slice(0, half).join(' ');
      const right = words.slice(half).join(' ');
      if (normalizeTitleKey(left) === normalizeTitleKey(right)) text = left;
    }
    return text;
  }

  function cartDisplayTitle(item) {
    const product = dedupeRepeatedTitle(item?.product_title);
    const variant = dedupeRepeatedTitle(item?.variant_title);
    if (!variant || variant === 'Default Title') return product;
    const productKey = normalizeTitleKey(product);
    const variantKey = normalizeTitleKey(variant);
    if (!variantKey || variantKey === productKey) return product;
    if (productKey.startsWith(variantKey + ' ')) return product;
    if (variantKey.startsWith(productKey + ' ')) {
      const productWordCount = productKey.split(' ').length;
      const variantWords = variant.split(/\s+/);
      const prefixKey = normalizeTitleKey(variantWords.slice(0, productWordCount).join(' '));
      if (prefixKey === productKey) {
        const suffix = variantWords.slice(productWordCount).join(' ').replace(/^[\s\-—|/:]+/, '').trim();
        return suffix ? product + ' — ' + suffix : product;
      }
    }
    return product + ' — ' + variant;
  }

  function cartVariantOptions(item) {
    const options = Array.isArray(item?.options_with_values) ? item.options_with_values : [];
    const meaningful = options
      .map((option) => ({ name: String(option?.name || '').trim(), value: String(option?.value || '').trim() }))
      .filter((option) => option.value && option.value !== 'Default Title')
      .map((option) => ({ name: !option.name || option.name === 'Title' ? 'Option' : option.name, value: option.value }));
    if (meaningful.length) return meaningful;
    const variant = dedupeRepeatedTitle(item?.variant_title);
    return variant && variant !== 'Default Title' && normalizeTitleKey(variant) !== normalizeTitleKey(item?.product_title)
      ? [{ name: 'Option', value: variant }]
      : [];
  }

  function cartVariantMarkup(item) {
    const options = cartVariantOptions(item);
    return options.length ? `<dl class="scd-options">${options.map((option) => `<div><dt>${escapeHtml(option.name)}</dt><dd>${escapeHtml(option.value)}</dd></div>`).join('')}</dl>` : '';
  }

  function ensureDrawer() {
    let drawer = $('shopify-cart-drawer');
    if (drawer) return drawer;
    document.head.insertAdjacentHTML('beforeend', `<style id="shopify-cart-drawer-style">
      .scd-backdrop{position:fixed;inset:0;z-index:9998;background:rgba(7,12,18,.68);opacity:0;pointer-events:none;transition:.2s}
      .scd-backdrop.open{opacity:1;pointer-events:auto}.scd-panel{position:absolute;right:0;top:0;width:min(510px,100%);height:100%;overflow:auto;background:#fff;box-shadow:-18px 0 50px rgba(0,0,0,.2);transform:translateX(100%);transition:.25s}
      .scd-backdrop.open .scd-panel{transform:none}.scd-head{display:flex;justify-content:space-between;align-items:center;padding:28px 30px;border-bottom:1px solid #d9dde2}.scd-kicker{font-size:11px;font-weight:900;letter-spacing:.14em}.scd-head h2{font:800 34px var(--condensed);margin:4px 0 0}.scd-close{position:relative;width:38px;height:38px;border:0;background:#f0f2f4;cursor:pointer;display:block;padding:0;font-size:0;line-height:0}.scd-close::before,.scd-close::after{content:"";position:absolute;left:50%;top:50%;width:17px;height:2px;background:#1d2731;transform-origin:center}.scd-close::before{transform:translate(-50%,-50%) rotate(45deg)}.scd-close::after{transform:translate(-50%,-50%) rotate(-45deg)}.scd-body{padding:0 30px}.scd-line{padding:24px 0;border-bottom:1px solid #d9dde2}.scd-title-row,.scd-total{display:flex;justify-content:space-between;gap:20px}.scd-title-row h3{font-size:17px;line-height:1.25}.scd-bike{display:block;margin-top:6px;color:#0877ef;font-size:12px;font-weight:800}.scd-options{margin:8px 0 0;display:grid;gap:4px;font-size:12px}.scd-options div{display:flex;gap:6px}.scd-options dt{font-weight:800}.scd-options dt::after{content:':'}.scd-options dd{margin:0;color:#44515e}.scd-meta{font-size:12px;color:#606974;margin:6px 0 15px}.scd-actions{display:flex;justify-content:space-between;align-items:center}.scd-qty{display:flex;border:1px solid #d9dde2}.scd-qty button,.scd-qty span{width:42px;height:40px;display:grid;place-items:center;border:0;background:#fff;font-weight:800}.scd-qty button{cursor:pointer}.scd-remove{border:0;background:none;text-decoration:underline;cursor:pointer}.scd-foot{padding:26px 30px}.scd-total{font-size:18px;font-weight:800;padding-bottom:22px}.scd-review{display:flex;justify-content:space-between;background:#0877ef;color:#fff;padding:17px 20px;font-weight:900;text-decoration:none}.scd-empty{padding:50px 0;text-align:center}.scd-note{font-size:12px;color:#606974;margin-top:14px}.scd-loading{padding:45px;text-align:center}@media(max-width:600px){.scd-head,.scd-body,.scd-foot{padding-left:20px;padding-right:20px}}
    </style>`);
    document.body.insertAdjacentHTML('beforeend', `<div class="scd-backdrop" id="shopify-cart-drawer" aria-hidden="true"><aside class="scd-panel" role="dialog" aria-modal="true" aria-label="Your cart"><header class="scd-head"><div><span class="scd-kicker">PNW COBRA</span><h2>YOUR CART</h2></div><button class="scd-close" aria-label="Close cart">×</button></header><div id="scd-content" class="scd-loading">Loading cart…</div></aside></div>`);
    drawer = $('shopify-cart-drawer');
    drawer.addEventListener('click', (event) => { if (event.target === drawer || event.target.closest('.scd-close')) closeCart(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });
    return drawer;
  }

  async function getCart() {
    const response = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  async function updateBadge(cart) {
    const currentCart = cart || await getCart();
    const count = $('cart-count');
    if (count) count.textContent = String(currentCart.item_count || 0);
    document.querySelectorAll('[data-cart-count]').forEach((element) => { element.textContent = String(currentCart.item_count || 0); });
    return currentCart;
  }

  function renderCart(cart) {
    const content = $('scd-content');
    if (!content) return;
    content.className = '';
    if (!cart.items.length) {
      content.innerHTML = '<div class="scd-body"><div class="scd-empty"><h3>Your cart is empty</h3><p>Find the exact parts for your Cobra.</p></div></div><div class="scd-foot"><a class="scd-review" href="/#shop"><span>Shop parts</span><span>→</span></a></div>';
      return;
    }
    content.innerHTML = `<div class="scd-body">${cart.items.map((item) => `<article class="scd-line"><div class="scd-title-row"><div><h3>${escapeHtml(dedupeRepeatedTitle(item.product_title))}</h3>${cartVariantMarkup(item)}${item.properties?.Bike ? `<small class="scd-bike">${escapeHtml(item.properties.Bike)}</small>` : ''}</div><strong>${money(item.final_line_price, cart.currency)}</strong></div><p class="scd-meta">${escapeHtml(item.sku || 'PNW Cobra')} · ${money(item.final_price, cart.currency)} each</p><div class="scd-actions"><div class="scd-qty"><button data-cart-key="${escapeHtml(item.key)}" data-cart-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button data-cart-key="${escapeHtml(item.key)}" data-cart-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button></div><button class="scd-remove" data-cart-key="${escapeHtml(item.key)}" data-cart-qty="0">Remove</button></div></article>`).join('')}</div><div class="scd-foot"><div class="scd-total"><span>Subtotal</span><strong>${money(cart.total_price, cart.currency)}</strong></div><a class="scd-review" href="/cart"><span>Review cart</span><span>→</span></a><p class="scd-note">Taxes and shipping are calculated at checkout.</p></div>`;
    content.querySelectorAll('[data-cart-key]').forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      try {
        const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: button.dataset.cartKey, quantity: Number(button.dataset.cartQty) }) });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to update cart');
        const updatedCart = await response.json();
        renderCart(updatedCart);
        updateBadge(updatedCart);
      } catch (error) {
        toast(error.message);
        button.disabled = false;
      }
    }));
  }

  async function openCart() {
    const drawer = ensureDrawer();
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    $('scd-content').innerHTML = 'Loading cart…';
    $('scd-content').className = 'scd-loading';
    try { renderCart(await updateBadge()); } catch (error) { $('scd-content').textContent = error.message; }
  }

  function closeCart() {
    const drawer = $('shopify-cart-drawer');
    if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }


  function cartBike() {
    const hash = location.hash || '';
    if (hash.startsWith('#fiche/')) {
      const selectLabel = [$('year')?.value, $('make')?.value, $('model')?.value].filter(Boolean).join(' ');
      const match = hash.match(/^#fiche\/([^?]+)/);
      const id = match ? decodeURIComponent(match[1]) : '';
      const assembly = window.PNW_CATALOG?.assemblies?.find((entry) => entry.id === id);
      const catalogLabel = assembly ? [assembly.year, assembly.make, assembly.model].filter(Boolean).join(' ') : '';
      const label = selectLabel || catalogLabel;
      if (label) sessionStorage.setItem('pnw_cart_bike', label);
      return label;
    }
    return hash.startsWith('#product/') ? (sessionStorage.getItem('pnw_cart_bike') || '') : '';
  }

  async function addSku(sku, quantity) {
    const requested = String(sku || '').trim();
    const value = /^retail:/i.test(requested) ? requested : resolvePartNumber(requested);
    if (value !== requested.toUpperCase() && !handles[clean(value)]) {
      throw new Error(`Part ${requested} has been superseded by ${value}. The replacement is not available for online ordering yet.`);
    }
    const direct = value.match(/^retail:(\d+)$/i);
    let variantId = direct ? Number(direct[1]) : 0;
    if (!variantId) {
      const response = await fetch(`/products/${encodeURIComponent(handleFor(value))}.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Product ${value} is not available in Shopify`);
      const product = await response.json();
      const variant = product.variants.find((entry) => clean(entry.sku) === clean(value)) || product.variants[0];
      variantId = variant.id;
    }
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: variantId, quantity: Math.max(1, Number(quantity) || 1), properties: cartBike() ? { Bike: cartBike() } : {} }] }) });
    if (!response.ok) throw new Error((await response.json()).description || 'Unable to add this item');
    await openCart();
  }

  function displayedSku() {
    const text = ($('retail-sku')?.textContent || '').trim();
    const mapped = Object.keys(handles).find((sku) => text.toLowerCase().includes(sku));
    return mapped || document.querySelector('[data-retail-variant][aria-pressed="true"]')?.dataset.sku || '';
  }

  window.addEventListener('click', (event) => {
    const target = event.target.closest('a,button');
    if (!target) return;
    const href = target.getAttribute('href') || '';
    if (href.startsWith('#product/') && (location.hash || '').startsWith('#fiche/')) cartBike();
    if (target.id === 'cart-button' || href === '#cart') { event.preventDefault(); event.stopImmediatePropagation(); openCart(); return; }
    if (href === '#checkout') { event.preventDefault(); location.href = '/checkout'; return; }


    const sku = target.id === 'retail-add' ? displayedSku() : (target.dataset.add || '');
    if (!sku) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const quantity = target.id === 'retail-add' ? document.querySelector('[data-qty]')?.value : 1;
    target.disabled = true;
    addSku(sku, quantity).catch((error) => toast(error.message)).finally(() => { target.disabled = false; });
  }, true);

  function clearSavedAvailability() {
    bindCartButton();
    document.querySelectorAll('[data-add], #retail-add').forEach((button) => { if (button.disabled) button.disabled = false; if (button.id === 'retail-add' && button.textContent !== 'Add to cart +') button.textContent = 'Add to cart +'; });
    document.querySelectorAll('.unavailable-label').forEach((label) => label.remove());
    const availability = $('retail-availability');
    if (availability && availability.textContent !== 'Available to order') availability.textContent = 'Available to order';
  }

  document.documentElement.dataset.pnwReady = 'yes';
  function bindCartButton() {
    const button = $('cart-button');
    if (!button || button.dataset.shopifyCartBound === 'yes') return;
    button.dataset.shopifyCartBound = 'yes';
    button.addEventListener('click', (event) => { event.preventDefault(); event.stopImmediatePropagation(); openCart(); }, true);
  }
  bindCartButton();

  new MutationObserver(clearSavedAvailability).observe(document.documentElement, { childList: true, subtree: true });
  clearSavedAvailability();
  updateBadge().catch(() => {});
})();
